module.exports = __webpack_public_path__ + "img/Angela Chen.06673b75.jpg";